/* eslint-disable react/prop-types */
import ComposedViewBannerPartnerComponent from "./composed-view-banner-partner";
function ComposedViewBannerPartner({ image, link, className }) {
  const handleClick = () => {
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <ComposedViewBannerPartnerComponent
      image={image}
      className={className}
      onClick={handleClick}
    />
  );
}

export default ComposedViewBannerPartner;
